import { render, staticRenderFns } from "./ModulesMultiSelect.vue?vue&type=template&id=12d2e488"
import script from "./ModulesMultiSelect.vue?vue&type=script&lang=js"
export * from "./ModulesMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports